module.exports = __webpack_public_path__ + "static/media/Richard.20451be7.png";